export default __webpack_public_path__ + "assets/images/a95541221a31da35ecec3c428f23e3e6.png";